import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateMotorForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: "",
        power: "",
        public_id: "",
    })
    const {name, power, public_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {motor} = location.state
            setFormData({
                name: motor.name,
                power: motor.power,
                public_id: motor.public_id
            })
        }

    }, [location])

    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {name, power}
        updateMotor(payload)
    }

    //update motor
    const updateMotor = async (payload) => {
        try {
            setIsLoading(true)
            // console.log(payload, public_id)
            // setIsLoading(false)
            // return;
            const response = await Server.put(`/motors/${public_id}`, payload)
            if(response.status === 200){
                toast.success('Successfully updated')
                navigate('/motors')
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header d-flex p-2 bg-info justify-content-center">
                <h3 className="card-title">Update Motor Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Motor Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>

                        <div className="col-md-3">
                            <InputField
                                placeholder="Motor Power"
                                name="power"
                                type="text"
                                label="Power"
                                value={power}
                                onChange={onChange}
                                error={errors.power}
                            />
                        </div>
                    </div>
                    <br/>
                    <input type="submit" className="btn btn-outline-info btn-block " value="Update Motor"/>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateMotorForm
